export const WEB_API_URLS = {
    production: 'https://web-api.migros.ch',
    test: 'https://test-web-api.migros.ch',
    development: 'https://dev-web-api.migros.ch',
    local: 'http://localhost:8000',
};
